export const ProgressBarProject = ({
    porcentaje,
    color,
}) =>{
    return(
        <div className="bg-[#d8d8d8] rounded relative h-[5px] w-full ">
            <div
                style={{width: porcentaje ? porcentaje + '%' : 0,
                    background: color ? color: '#d8d8d8'
                }}
                className={`h-full text-black flex items-center justify-center opacity-70 transition ease-in duration-300 rounded`}
            >
                {/* <span className="text-black text-xs absolute">{porcentaje||'0'}</span>% */}
            </div>
        </div>
    )
}